import { PAGE_NAV_TITLE as SYSTEM_PAGE_NAV_TITLE } from "components/system-overview/bindings";
import HealthAlertEventDefinitionFormContainer from "./alert/HealthAlertEventDefinitionFormContainer";
import HealthAlertEventDefinitionSummary from "./alert/HealthAlertEventDefinitionSummary";
import { HEALTH_ALERT_TYPE } from "./alert/types";
import HealthPage from "./HealthPage";
import HealthRoutes from "./Routes";
import HealthStatusBadge from "./HealthStatusBadge";
import useHealthModuleVisible, { HEALTH_MODULE_PERMISSIONS } from "./useHealthModuleVisible";
const healthAlertDefaultConfig = { type: HEALTH_ALERT_TYPE, targets: [], statuses: [] };
const healthBindings = {
  "navigation.badges": [
    {
      key: "org.graylog.plugins.health.HealthStatusBadge",
      component: HealthStatusBadge,
      useCondition: useHealthModuleVisible
    }
  ],
  routes: [{ path: HealthRoutes.unqualified.OVERVIEW, component: HealthPage, permissions: HEALTH_MODULE_PERMISSIONS }],
  eventDefinitionTypes: [
    {
      type: HEALTH_ALERT_TYPE,
      displayName: "Health Alert",
      displayNameKey: "enterprise_common:event_definition_types.health.title",
      sortOrder: 5,
      description: "Fires when the cluster or a health check changes to a chosen status.",
      descriptionKey: "enterprise_common:event_definition_types.health.description",
      defaultConfig: healthAlertDefaultConfig,
      formComponent: HealthAlertEventDefinitionFormContainer,
      summaryComponent: HealthAlertEventDefinitionSummary,
      useCondition: () => true,
      hideFieldsStep: true,
      hideFromCreation: true
    }
  ],
  pageNavigation: [
    {
      description: SYSTEM_PAGE_NAV_TITLE,
      children: [
        {
          description: "Health",
          titleKey: "enterprise_navigation:system_page.health",
          path: HealthRoutes.OVERVIEW,
          position: { after: "Overview" },
          permissions: HEALTH_MODULE_PERMISSIONS,
          useCondition: useHealthModuleVisible
        }
      ]
    }
  ]
};
export default healthBindings;
